import { render, staticRenderFns } from "./listTabA.vue?vue&type=template&id=1cf1b2a4&scoped=true"
import script from "./listTabA.vue?vue&type=script&lang=js"
export * from "./listTabA.vue?vue&type=script&lang=js"
import style0 from "./listTabA.vue?vue&type=style&index=0&id=1cf1b2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1b2a4",
  null
  
)

export default component.exports